import React from 'react';
import { Component } from 'react';
import './FeatureListItem.less'

class FeatureListItemUpdated extends Component {
    render() {
        return <div className='feature-list-item-updated'>
            <img src='https://com-syndafy-dealgrace-static.s3.us-east-2.amazonaws.com/checkmark-green_1gmhgfx4krkwr9sn_.svg'></img>
            <div className={`feature-list-item-updated-content${this.props.isHighlighted ? ' highlighted' : ''}`}>{this.props.content}</div>
        </div>
    }
}

export default FeatureListItemUpdated;